var portfolioTransactionDelete = {
	title: "Transactie verwijderen",
	alertHeading: "Weet u zeker dat u deze transactie wilt verwijderen?",
	alertBody: "Zo ja, klik dan op 'Ok'. Houd er rekening mee dat verwijderde transacties niet kunnen worden hersteld",
	confirmBtn: "Ok",
	cancelBtn: "Annuleren"
};
var nl = {
	portfolioTransactionDelete: portfolioTransactionDelete
};

export { nl as default, portfolioTransactionDelete };
